export const LAUNCHPAD_ABI = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "token_",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokensToBuy",
				"type": "uint256"
			}
		],
		"name": "buy",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "name_",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "symbol_",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "backendHash_",
				"type": "string"
			},
			{
				"internalType": "uint256",
				"name": "totalSupply_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "softCap_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "ownerAllocation_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "saleStart_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "saleEnd_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "totalPriceWei_",
				"type": "uint256"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "vestedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "cliff",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "duration",
						"type": "uint256"
					}
				],
				"internalType": "struct MultiLaunchpad.VestingParams",
				"name": "creatorVesting_",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "vestedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "cliff",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "duration",
						"type": "uint256"
					}
				],
				"internalType": "struct MultiLaunchpad.VestingParams",
				"name": "userVesting_",
				"type": "tuple"
			}
		],
		"name": "createSale",
		"outputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "token_",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "user_",
				"type": "address"
			}
		],
		"name": "finishSale",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "token_",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "beneficiary_",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount_",
				"type": "uint256"
			}
		],
		"name": "releaseTreasury",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "vesting_",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "feeReceiver_",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnableInvalidOwner",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "OwnableUnauthorizedAccount",
		"type": "error"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "natSpent",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "tokensBought",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "bool",
				"name": "reached",
				"type": "bool"
			}
		],
		"name": "SaleClosed",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "creator",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "totalSupply",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "softCap",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "ownerAllocation",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "saleStart",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "saleEnd",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "totalPriceWei",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "backendHash",
				"type": "string"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "vestedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "cliff",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "duration",
						"type": "uint256"
					}
				],
				"indexed": false,
				"internalType": "struct MultiLaunchpad.VestingParams",
				"name": "creatorVesting",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "vestedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "cliff",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "duration",
						"type": "uint256"
					}
				],
				"indexed": false,
				"internalType": "struct MultiLaunchpad.VestingParams",
				"name": "userVesting",
				"type": "tuple"
			}
		],
		"name": "SaleCreated",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newReceiver_",
				"type": "address"
			}
		],
		"name": "setFeeReceiver",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "newFeeBps_",
				"type": "uint256"
			}
		],
		"name": "setPlatformFee",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newVesting_",
				"type": "address"
			}
		],
		"name": "setVestingContract",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "buyer",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "TokensPurchased",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "beneficiary",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "TreasuryReleased",
		"type": "event"
	},
	{
		"stateMutability": "payable",
		"type": "receive"
	},
	{
		"inputs": [],
		"name": "feeReceiver",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "platformFeeBps",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "sales",
		"outputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "creator",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "saleStart",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "saleEnd",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "startingSaleSupply",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "supplyForSale",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "supplySold",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "natTreasury",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "totalPriceWei",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "softCap",
				"type": "uint256"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "vestedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "cliff",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "duration",
						"type": "uint256"
					}
				],
				"internalType": "struct MultiLaunchpad.VestingParams",
				"name": "creatorVesting",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "vestedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "cliff",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "duration",
						"type": "uint256"
					}
				],
				"internalType": "struct MultiLaunchpad.VestingParams",
				"name": "userVesting",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "token_",
				"type": "address"
			}
		],
		"name": "softCapReached",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
]